import React from "react";
import "./login.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { CButton, CFormInput, CForm, CFormLabel, CCol } from "@coreui/react";
import pic from "./images/logo.jpg";
import pic2 from "./images/PAYROLL.jpg";
import pic3 from "./images/nature.jpg";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import * as icon from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import axios, { Axios } from "axios";
import { Redirect } from "react-router-dom";
import Home from "./home";
import DefaultLayout from "./DefaultLayout";
import "@coreui/coreui/dist/css/coreui.min.css";
import Appconfig from "../APPconfig";

<link
  rel="stylesheet"
  href="https://unpkg.com/@coreui/coreui/dist/css/coreui.min.css"
/>;


const Login = () => {
  const [validated, setValidated] = useState(false);
  const [divvisiable, setdivvisibale] = useState(true);
  const [emailInput, setEmailInput] = useState();
  const [passwordInput, setPasswordInput] = useState();
  const [error, setError] = useState();
  const [compid, setcompid] = useState(2030);
  const navigate = useNavigate();
  const [user, setUser] = useState();
  const [email, setEmail] = useState();
  const [docentry, setDocentry] = useState();
  const [pass, setPass] = useState();
  const [logo, setlogo] = useState('');
  
  useEffect(() => {
    const url = Appconfig.URL + `/CompanySetup/${compid}`;
    const fetchData = async () => {
      try {
        const response = await fetch(url);
        const json = await response.json();
        localStorage.setItem("cmplogo", json.records[0].Image);
        setlogo(json.records[0].Image);
        //alert(JSON.stringify(json))
      } catch (error) {
        console.log("error", error);
      }
    };
    fetchData();
  }, []);
  async function Login(e) {
    e.preventDefault();
    const user = [{ EmailId: emailInput, Password: passwordInput }];
    await axios
      .post(Appconfig.URL + "/users/login", {
        EmailId: emailInput,
        Password: passwordInput,
      },{
        headers: {
          compid: compid,
        },
      })
      .then((response) => {
        if (response.data.Statusflag == "Yes") {
          setUser(response.data);
          //alert(JSON.stringify(response.data));
          // store the user in localStorage
          localStorage.setItem("docentry", response.data.Message[0].DocEntry);
          localStorage.setItem("user", response.data.Message[0].Name);
          localStorage.setItem("usercode", response.data.Message[0].Code);
          localStorage.setItem("email", response.data.Message[0].EmailId);
          localStorage.setItem("empid", response.data.Message[0].EMPEntry == null ? 0 : response.data.Message[0].EMPEntry);
          localStorage.setItem("compid", response.data.Message[0].Compid);
          localStorage.setItem("ugpentry", response.data.Message[0].UgpEntry);
          localStorage.setItem("cmpname", response.data.Message[0].CompanyName);
          localStorage.setItem("APPEntry", 0); 
          localStorage.setItem("TRAEntry", 0); 
          localStorage.setItem("TRREntry", 0); 
          localStorage.setItem("APPEntry1", 0); 
          localStorage.setItem("APPType", "N"); 
          localStorage.setItem("GRDEntry", response.data.Message[0].GRDEntry); 
          localStorage.setItem("GRDName", response.data.Message[0].GRDName); 
           localStorage.setItem("EMPCode", response.data.Message[0].EMPCode); 
          localStorage.setItem("EMPName", response.data.Message[0].EMPName); 
          localStorage.setItem("CostCenter", response.data.Message[0].CostCenter); 
          
          //localStorage.setItem("LoadNot", true); 
          // localStorage.setItem("docentry", response.data.Message[0].DocEntry);
          // localStorage.setItem("user", response.data.Message[0].Name);
          // localStorage.setItem("email", response.data.Message[0].EmailId);
          // localStorage.setItem("pass", response.data.Message[0].Password);
          // localStorage.setItem("Usergrp", response.data.Message[0].UgpEntry);
          // localStorage.setItem("USRImage", response.data.Message[0].Image)

          navigate("/DefaultLayout");
        } else {
          setError(response.data.Message);
        }
      });
  }
  function login() {
    setdivvisibale(true);
    return false;
  }
  function back() {
    setdivvisibale(false);
    return false;
  }



  return (
    <>
      <div
        className="background-branding-container"
        id="background-branding-container"
       
      >
        <img id="login-background-image" src={pic3}></img>
      </div>
      <div
        id="background-branding-overlay"
        className="overlay ie_legacy"
        style={{
          visibility: "visible",
          backgroundColor: "rgb(0, 114, 198)",
          display: "none",
        }}
      ></div>
      <div
        id="login-container"
        className="login-container"
        style={{ display: "block" }}
      >
        <table class="login-container-layout">
          <tbody>
            <tr>
              <td id="login-container-center" style={{ height: "548px" }}>
                <div className="credentials-container">
                  <div className="row">
                    <div className="Col-md-12"  style={{textAlign:"center"}}>
                      <img className="logo" src={logo == "" ? pic : logo}></img>
                    </div>
                  </div>
                  <div className="spacer"></div>
                  {/* <div className="row">
                    <div className="Col-md-12">
                      <h4 className="login">Login</h4>
                      <div style={{ display: divvisiable ? "block" : "none" }}>
                      
                        <CIcon
                          icon={icon.cilArrowLeft}
                          width="20px"
                          onClick={back}
                          style={{
                            float: "right",
                            color: "#0d6efd",
                            cursor: "pointer",
                          }}
                          color="primary"
                        />
                       
                      </div>
                    </div>
                  </div> */}
                  <div
                    style={{ display: divvisiable == false ? "block" : "none" }}
                  >
                    <div className="row">
                      <div className="Col-md-12">
                        <CButton type="submit" className="btn-login">
                          {" "}
                          Login with Google
                        </CButton>
                      </div>
                    </div>
                    <div className="row">
                      <div className="Col-md-12">
                        <CButton
                          type="submit"
                          className="btn-login2"
                          onClick={login}
                        >
                          {" "}
                          Login with Zyple Payroll Password
                        </CButton>
                      </div>
                    </div>
                  </div>
                  <div style={{ display: divvisiable ? "block" : "none" }}>
                    <CForm noValidate validated={validated}>
                      <div className="row">
                        <div className="Col-md-12">
                          <CFormInput
                            label=""
                            type="text"
                            id="EmailID"
                            placeholder="EMP ID"
                            value={emailInput}
                            onChange={(e) => {
                              setEmailInput(e.target.value);
                            }}
                            //feedbackInvalid="Please provide a valid Email ID."
                            required
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="Col-md-12">
                          <CFormInput
                            label=""
                            type="Password"
                            id="Password"
                            placeholder="Password"
                            value={passwordInput}
                            onChange={(e) => {
                              setPasswordInput(e.target.value);
                            }}
                            required
                            //feedbackInvalid="Please provide a valid password."
                            style={{ marginTop: "20px" }}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="Col-md-12">
                          <CButton
                            type="submit"
                            style={{ marginTop: "20px", width: "100%" }}
                            onClick={Login}
                          >
                            Login
                          </CButton>
                        </div>
                      </div>
                      {error && <div style={{ color: "#eb4638" }}>{error}</div>}
                    </CForm>
                  </div>
                  <div className="row">
                    <div className="Col-md-12">
                      <div class="login-org-cobranding">
                        <img src={pic2}></img>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="footer-zyple">
                        <span>
                          © 2023 Powered By{" "}
                          <a href="https://www.zyplesoft.com/">
                            Zyple Software
                          </a>
                          . All Rights Reserved
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
export default Login;
